import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TramiteDto } from './model/model';
import { ReturnData } from './rest/rest.service';
import { TramiteConsultaQRService } from './service/tramite-consulta-qr.service';
import { ConstanciaDto } from './model/constancia-model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public selectItem = new TramiteDto();
  public selectItemConstancia = new ConstanciaDto();

  public errorTramite: boolean = false;
  public errorConstancia: boolean = false;
  public errorMensaje: string = "";

  @ViewChild('scroll', { static: true })
  public scroll!: ElementRef;

  constructor(
    public restService: TramiteConsultaQRService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {

    const _self = this;
    _self.route.queryParams.subscribe(params => {
      if (params.s !== undefined && params.s !== '' && params.id !== undefined && params.id !== '') {
        if (params.c == undefined || params.c == '' || params.c == 'N') {
          try {
            this.restService.GetTramiteQR(this, { id: params.id, s: params.s, nc: params.nc !== undefined ? params.nc : '' }, (r: ReturnData) => {
              if (!r.isError) {
                this.selectItem = r.data;
                this.errorTramite = false;
                this.errorMensaje = "";
              } else {
                this.errorTramite = true;
                this.errorMensaje = r.data;
              }
            });
          } catch (error) {
          }
        } else {
          try {
            this.restService.GetConstanciaQR(this, { id: params.id, s: params.s, nc: params.nc !== undefined ? params.nc : '' }, (r: ReturnData) => {
              if (!r.isError) {
                this.selectItemConstancia = r.data;
                this.errorConstancia = false;
                this.errorMensaje = "";
              } else {
                this.errorConstancia = true;
                this.errorMensaje = r.data;
              }
            });
          } catch (error) {
          }
        }

      }
    });
  }

  public descargarConstancia() {
    this.restService.ReImpresion(this, this.selectItemConstancia.idTramite, this.selectItemConstancia.idhistorialimpresion, 'Constancia de Habilitación', (e: ReturnData) => {
      if (!e.isError) {
        this.errorMensaje = "Se ha descargado la constancia correctamente";
        this.errorConstancia = false;
      } else {
        this.errorMensaje = e.data;
        this.errorConstancia = true;
      }
    });
  }

}
